
<template>
  <div>
    <div v-if="checkinNowRequired">
      <v-btn @click="doCheckin" class="error" :loading="loading">
        <v-icon left>mdi-bag-checked</v-icon>{{$t('competition.perform-check-in-title')}}
      </v-btn>
      <span class="overline"
        ><v-icon>mdi-arrow-left</v-icon>{{$t('competition.check-in-now-message')}}</span
      >
    </div>
    <div v-else>
      <span class="overline"
        ><v-icon left color="success">mdi-bag-checked</v-icon>{{$t('competition.your-participation-is-confirmed')}} <v-icon color="success">mdi-check</v-icon></span
      >
    </div>
  </div>
</template>

<script>
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store";
import {
  EVENT_REFRESH_DATA,
  EVENT_GAMEINSTANCE_UPDATED,
} from "@/plugins/eventbus";

export default {
  name: "GameCheckin",
  components: {},
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      loading: false,
    };
  },
  watch: {},
  computed: {
    checkinNowRequired: function () {
      return this.game.youCheckedIn === false;
    },
  },
  mounted() {
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },

  methods: {
    onRefreshData() {},
    doCheckin() {
      this.loading = true;
      this.$api
        .performGameCheckIn(this.game.uid)
        .then((response) => {
          this.loading = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: this.$t('competition.check-in-successful'),
            type: "success",
          });
          this.$eventBus.$emit(EVENT_GAMEINSTANCE_UPDATED, response.data);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.tabWithoutSlideIndicator >>> .v-slide-group__prev {
  display: none !important;
}
</style>
